import { CURRENT_MEMBERS_ACTIVITIES_EVENT_ID, CURRENT_MEMBERS_ACTIVITIES_EVENT_NAME } from "../constants/memActConstant"

export const setMemActEventId = (id) => async(dispatch) => {
    dispatch({
        type: CURRENT_MEMBERS_ACTIVITIES_EVENT_ID,
        payload: id
    })
}

export const setMemActEventName = (name) => async(dispatch) => {
    dispatch({
        type: CURRENT_MEMBERS_ACTIVITIES_EVENT_NAME,
        payload: name
    })
}